import { func_validation } from "functions";
import ic_delete from 'assets/images/ic_delete_invoices.svg';
import { Toaster } from "components/notification/Toaster";

export function postedDebitNote(props) {
    const {
        selectedDebitNotes,
    } = props;

    let filters = {
        postStatus: "knocked",
    }
    let tabDetails = {
        id: "posted",
        text: "Posted",
        filters
    };

    let tableActions = [
        {
            icon: ic_delete,
            label: "Delete",
            isDisabled: func_validation.isUserAccessDenied(props, "Internal_AdvancePay_Delete"),
            onClick: () => { 
                if (func_validation.isArrayNotEmpty(selectedDebitNotes)) {
                    if (func_validation.isFunction(props.setIsDeleteModalVisible))
                        props.setIsDeleteModalVisible(true);
                }
                else {
                    Toaster({
                        type: "info",
                        msg: "Please select at least 1 debit note.",
                    });
                }
            },
        }
    ];

    return {
        tabDetails,
        filters,
        tableActions
    };
}